/**
* @Author: zachalam
* @Date:   2017-03-15T16:16:14-07:00
* @Email:  zach@reflexmedia.com
* @Last modified by:   zachalam
* @Last modified time: 2017-03-15T16:16:14-07:00
*/




import React, { Component } from 'react';
import Blocked from '../components/pages/Settings/Blocked';
import { connect } from 'react-redux';
import { refreshBlockedList } from '../actions/profileActions';

class BlockedContainer extends Component {
  componentWillMount() {
    // refresh data on new page
    this.props.refresh();
  }

  render() {
    return (
      <Blocked {...this.props} />
    );
  }
}


const mapStateToProps = (state) => {
  return {
    blocked: state.blocked,
    moreExists: Boolean(state.meta.blocked_current_page < state.meta.blocked_total_pages)
  }
}

const mapDispatchToProps = (dispatch,ownProps) => {
  return {
    refresh: () => {
      dispatch(refreshBlockedList(true));
    },
    loadMore: () => {
      dispatch(refreshBlockedList(false));
    }
  }
}
export default connect(mapStateToProps,mapDispatchToProps)(BlockedContainer);



// WEBPACK FOOTER //
// ./src/containers/BlockedContainer.jsx